<template>
    <div class="content">
        <div class="topBox">
            <div class="leftImg">
                <img class="bannerImg" src="../../assets/images/homeBanner.png" alt="">
            </div>
            <div class="rightList">
                <div class="listTitle">
                    新课报名中!
                </div>
                <div class="VideoList">
                    <div class="videoItem" @click="jumpisvpsDetail(item)" v-for="(item, index) in IsvpsProductDataList" :key="index">
                        <div class="videoImgBox">
                            <img class="videoImg" src="../../assets/images/livebg.png" alt="">
                        </div>
                        <div class="videoInfo">
                            <div class="videoName">
                                {{ item.product_name }}
                            </div>
                            <div class="videoTime">
                                开课时间：{{ item.start_time.slice(0, 10)}}
                            </div>
                            <div class="videoBtn">
                                立即学习
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="jumpBtnList">
            <div class="jumpBtnItem" @click="jumpWeb(1)" >
                <img src="../../assets/images/isvpsIcon1.png" alt="">
                <div class="name">证书持有者</div>
            </div>
            <div class="jumpBtnItem" @click="jumpWeb(2)" >
                <img src="../../assets/images/isvpsIcon2.png" alt="">
                <div class="name">大咖讲师</div>
            </div>
            <div class="jumpBtnItem" @click="jumpWeb(3)" >
                <img src="../../assets/images/isvpsIcon3.png" alt="">
                <div class="name">My Improve</div>
            </div>
            <div class="jumpBtnItem" @click="jumpWeb(4)" >
                <img src="../../assets/images/isvpsIcon4.png" alt="">
                <div class="name">常见的Q&A</div>
            </div>
        </div>

        <!-- 我的课程 -->
        <div class="myProductBox">
            <div class="title">我的课程</div>
            <div class="productInfo" @click="jumpisvpsVideoDetail(UserProductDataList)">
                <img class="productImg" :src="imgSrc + UserProductDataList.image" alt="">
                <div class="infoBox">
                    <div class="name">{{UserProductDataList.product_name}}</div>
                    <div class="texts">开课时间: {{ UserProductDataList.start_time.slice(0,4) + "/" +  UserProductDataList.start_time.slice(5,7)  }}</div>
                    <div class="texts">课程已更新至: {{ UserProductDataList.recently_updated_series }}</div>
                    <div class="texts">下期直播时间: {{ UserProductDataList.up_time }}</div>
                </div>
            </div>
        </div>

        <!-- 视频课程 -->
        <div class="myVideoDataListBox">
            <div class="title">视频课程</div>
            <div class="videoDataList">
                <div class="videoItem" @click="jumpisvpsVideoDetail(item)" v-for="(item, index) in UserVideoDataList" :key="index">
                    <div class="videoImgBox">
                        <img class="videoImg" :src="imgSrc+item.image" alt="">
                    </div>
                    <div class="videoInfo">
                        <div class="videoName">
                            {{ item.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
			imgSrc: "https://case.chongyike.com",
            // 产品列表
            IsvpsProductDataList: [],
            // 用户产品列表
            UserProductDataList: {
                start_time: ""
            },
            // 用户课程列表
            UserVideoDataList: [],
        }
    },
    created(){
        const that = this
        that.getIsvpsProductList()
        that.getUserProductList()
        that.getUserVideoList()
    },
    methods: {
        jumpWeb(index){
            if (index == 1) {

            }else if(index == 2){
                window.open("http://www.improveinternational.cn/speaker/")
            }else if(index == 3){
                window.open("http://www.improveinternational.cn/")
            }else if(index == 4){
                
            }
        },
        jumpisvpsDetail(item){
            const that = this
			this.$router.push({
				path: "/isvpsDetail/" + item.p_id,
			})
        },
        jumpisvpsVideoDetail(item){
            const that = this
            var data = {
                dataType: 'isvps',
                No: item.v_no,
				name: item.name,
                classType: '10',
                classId: item.c_id
            }
            that.$router.push({
                path: '/isvpsVideoDetail',
                query: {
                    text: that.encrypt(JSON.stringify(data))
                }
            })
        },
        // 获取产品列表
        getIsvpsProductList(){
            const that = this
            var data = {
                type: 'getIsvpsProductList',
            }
            this.get("/4/isvps", data).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    that.IsvpsProductDataList = result
                } 
            })
        },
        // 获取用户产品列表
        getUserProductList(){
            const that = this
            var data = {
                type: 'getUserProductList',
            }
            this.get("/4/isvps", data).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    that.UserProductDataList = result[0]
                } 
            })
        },
        // 获取用户课程列表
        getUserVideoList(){
            const that = this
            var data = {
                type: 'getUserVideoList',
            }
            this.get("/4/isvps", data).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    console.log(result[0])
                    that.UserVideoDataList = result
                } 
            })
        },
        // 获取新课详情
        getIsvpsProductInfo(item){
            const that = this
            var data = {
                type: 'getIsvpsProductInfo',
                productId: item.p_id
            }
            this.get("/4/isvps", data,1).then((res) => {
                if (res.data.code == "success") {
                    var result = this.decrypt(res.data.result)
                    console.log(JSON.parse(result))
                } 
            })
        },
        // 获取课程列表
        getIsvpsProductSeriesList(item){
            const that = this
            var data = {
                type: 'getIsvpsProductSeriesList',
                productId: item.p_id
            }
            this.get("/4/isvps", data,1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                } 
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    .topBox{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .leftImg {
            width: 710px;
            .bannerImg {
                width: 710px;
                height: 210px;
            }
        }
        .rightList {
            width: 450px;
            height: 210px;
            .listTitle {
                position: relative;
                padding-left: 12px;
                font-weight: 600;
                &::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 4px;
                    width: 5px;
                    height: 15px;
                    background-color: #40b0ff;
                }
            }
            .VideoList {
                overflow-x: auto;
                width: 450px;
                padding-top: 10px;
                display: flex;
                .videoItem {
                    overflow: hidden;
                    flex: 0 0 auto;
                    width: 140px;
                    height: 170px;
                    border-radius: 10px;
                    margin-left: 10px;
                    box-shadow: 0 0 3px 2px #eee;
                    cursor: pointer;
                    &:nth-child(1){
                        margin: 0;
                    }
                    .videoImgBox {
                        .videoImg {
                            width: 140px;
                            height: 90px;
                        }
                    }
                    .videoInfo {
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        .videoName {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            font-size: 12px;
                            color: #333333;
                            padding: 0 10px;
                        }
                        .videoTime {
                            padding: 2px 0;
                            font-size: 10px;
                            color: #636363;
                        }
                        .videoBtn {
                            padding: 0px 5px;
                            font-size: 10px;
                            border-radius: 100px;
                            color: #2e96df;
                            font-weight: 600;
                            border: 1px solid #96d4ff;
                        }
                    }
                }
            }
        }
    }

    .jumpBtnList {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 130px;
        .jumpBtnItem {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 18px;
            color: #232b4a;
            font-weight: 600;
            cursor: pointer;
            .name {
                padding-top: 10px;
            }
        }
    }

    .myProductBox, .myVideoDataListBox {
        .title {
            font-size: 30px;
            color: #333;
            font-weight: 600;
            padding-left: 10px;
            margin-bottom: 10px;
        }
        .productInfo {
            display: flex;
            padding: 20px 40px;
            border-radius: 10px;
            box-shadow: 0 0 3px 2px #eee;
            cursor: pointer;
            .productImg {
                width: 350px;
                height: 225px;
                margin-right: 40px;
                border-radius: 10px;
            }
            .infoBox {
                width: 730px;
                .name {
                    font-size: 30px;
                    color: #1a68e8;
                    font-weight: 600;
                    margin-bottom: 10px;
                }
                .texts {
                    font-size: 20px;
                    color: #494949;
                }
            }
        }
    }

    .myVideoDataListBox {
        margin-top: 20px;
        .videoDataList {
            overflow-x: auto;
            display: flex;
            padding-bottom: 10px;
            .videoItem {
                overflow: hidden;
                flex: 0 0 auto;
                width: 240px;
                height: 300px;
                border-radius: 10px;
                margin-left: 10px;
                box-shadow: 0 0 3px 2px #eee;
                cursor: pointer;
                &:nth-child(1){
                    margin: 0;
                }
                .videoImgBox {
                    .videoImg {
                        width: 240px;
                        height: 160px;
                    }
                }
                .videoInfo {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    .videoName {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-size: 24px;
                        color: #333333;
                        padding: 0 10px;
                    }
                    .videoTime {
                        padding: 2px 0;
                        font-size: 10px;
                        color: #636363;
                    }
                    .videoBtn {
                        padding: 0px 5px;
                        font-size: 10px;
                        border-radius: 100px;
                        color: #2e96df;
                        font-weight: 600;
                        border: 1px solid #96d4ff;
                    }
                }
            }
        }
    }
</style>